interface RoleCardProps {
  label: string;
  purpose: string;
  promise: string;
  selected: boolean;
  onSelect: () => void;
}

/** One of the four doors in step one of the spec. */
export default function RoleCard({ label, purpose, promise, selected, onSelect }: RoleCardProps) {
  return (
    <button type="button" className="role" aria-pressed={selected} onClick={onSelect}>
      <div className="rn">{label}</div>
      <div className="rp">{purpose}</div>
      <div className="rw">{promise}</div>
    </button>
  );
}
